import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RecaptchaFormsModule, RecaptchaModule, RecaptchaSettings, RECAPTCHA_SETTINGS } from 'ng-recaptcha';
import { environment } from 'src/environments/environment';
import { LoginRoutingModule } from './login-routing.module';
import { SharedModule } from 'src/app/@shared/shared.module';
import { LoginComponent } from './login/login.component';
import { ModalExpiracaoSenhaComponent } from './modal-expiracao-senha/modal-expiracao-senha.component';
import { ModalBloqueioSenhaComponent } from './modal-bloqueio-senha/modal-bloqueio-senha.component';
import { ComponentsModule } from 'src/app/@shared/components/components.module';

//...fromComponents.shared_components

@NgModule({
  declarations: [LoginComponent, ModalExpiracaoSenhaComponent, ModalBloqueioSenhaComponent],
  providers: [
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: { siteKey: environment.recaptchaKey } as RecaptchaSettings,
    },
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    SharedModule,
    ComponentsModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    LoginRoutingModule
  ],
  exports: [LoginComponent]
})
export class LoginModule {

}
